/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import {
    string, object, shape, arrayOf, bool,
} from 'prop-types';
import { compose } from 'recompose';
import ReactMarkdown from 'react-markdown';
import mbpLogger from '@module-logger/mbp';
import { useQuery } from '@apollo/client';
import GraphqlPDPPromotionalBlock from './GraphqlPDPPromotionBlock';
import findContent from '../../../../../gql/queries/findContent';
import { getBrand } from '../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';

const GraphqlPDPPromoDataContainer = ({
    brand,
    parentCategories,
    position,
    clubProductPage,
    featureFlags,
    isPdpRedesignEnabled,
}) => {
    const FIND_PROMO_QUERY = findContent({
        brand: brand?.domain,
        contentType: 'promo_messaging',
    });

    let response = null;

    const { loading, error, data } = useQuery(FIND_PROMO_QUERY);
    if (loading) {
        response = null;
    }
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: 'Failed load promo container',
        });
        response = <ReactMarkdown source="There has been an error retrieving details for this promotion. If this issue persists, please contact us." />;
    }

    const promoData = data?.findContent?.content?.entries;
    if (promoData?.length) {
        const promoSummary = promoData.find((promo) => parentCategories?.some((category) => promo?.category_id?.includes(category?.id))) || null;
        // finds the category id zinside the parentCategories - if found displays that promo summary
        const promoStyles = {
            background: promoSummary?.pdp_message_background_color?.color || '#fff',
            color: promoSummary?.pdp_message_font_color?.color || '#2f2f2f',
            border: promoSummary?.pdp_message_border || false,
            borderColor: promoSummary?.pdp_message_border_color?.color || '#ccc',
        };
        if (promoSummary?.pdp_message.length) {
            response = <GraphqlPDPPromotionalBlock promoSummary={promoSummary} promoStyles={promoStyles} position={position} clubProductPage={clubProductPage} featureFlags={featureFlags} isPdpRedesignEnabled={isPdpRedesignEnabled} />;
        } else response = <></>;
    }
    return response;
};

GraphqlPDPPromoDataContainer.propTypes = {
    brand: object.isRequired,
    categoryId: string,
    parentCategories: arrayOf(shape({
        id: string,
    })).isRequired,
    position: string,
    clubProductPage: bool,
    featureFlags: object.isRequired,
    isPdpRedesignEnabled: bool,
};

GraphqlPDPPromoDataContainer.defaultProps = {
    categoryId: '',
    position: 'Bottom',
    clubProductPage: false,
    isPdpRedesignEnabled: false,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

const enhance = compose(
    connect(mapStateToProps),
);

export default enhance(GraphqlPDPPromoDataContainer);
